@if (showButton()) {
  <!-- Enter must stop here: the login form submits on keyup.enter and the
       sign-in modal on keydown.enter, which would also send the password. -->
  <button
    type="button"
    class="btn btn-lg btn-outline w-100 sso-login-button"
    (click)="start()"
    (keydown.enter)="$event.stopPropagation()"
    (keyup.enter)="$event.stopPropagation()"
  >
    Continue with SSO
  </button>
}
